import getCssRootVariablesMap from './get-css-root-variables-map';

const getCssVariableNameByColor = (color, cssVariablesMap = getCssRootVariablesMap()) =>
  Object.keys(cssVariablesMap).find((cssVariable) => cssVariablesMap[cssVariable] === color);

export default getCssVariableNameByColor;
